import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab4',
  templateUrl: './awsop-lab4.component.html',
  styleUrls: ['./awsop-lab4.component.css']
})
export class AwsopLab4Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab4/awsop-lab4.component.ts